// SPDX-License-Identifier: MIT
// One-shot "the machine is Genesis-ready" flag. Set when the user finishes
// Étape ① (install + login + connect Genesis MCP). Drives the /welcome
// state dispatch: false → newcomer guided journey, true → dashboard.
const KEY = 'genesis.setupComplete';

export function isSetupComplete(): boolean {
  try { return localStorage.getItem(KEY) === '1'; } catch { return false; }
}
export function markSetupComplete(): void {
  try { localStorage.setItem(KEY, '1'); } catch { /* ignore */ }
}
export function clearSetupComplete(): void {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}
